import { GetPublicOverviewResponse } from '@orbit/api-types'
import { publicApi, publicQueryRetry } from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Query options for the aggregated Shared-trip endpoint, exported separately so
 * tests can pin the key/URL/retry without mounting the hook. Rides the shared
 * unauthenticated `publicApi` — the page must load identically for logged-out
 * and logged-in visitors — and never retries a deterministic 4xx (a
 * private/unknown code should show the unavailable state immediately).
 */
export const publicOverviewQueryOptions = (tripCode: string | undefined) => ({
	queryKey: queryKeys.publicOverview(tripCode),
	queryFn: async (): Promise<GetPublicOverviewResponse> => {
		if (!tripCode) throw new Error('Trip code is required')
		const response = await publicApi.get<GetPublicOverviewResponse>(
			`/trips/${tripCode}/public-overview`,
		)
		return response.data
	},
	enabled: !!tripCode,
	retry: publicQueryRetry,
})

export const usePublicOverview = (tripCode: string | undefined) =>
	useQuery(publicOverviewQueryOptions(tripCode))
